$(document).ready(() => {
  const apiURL = "https://stimulus-athletic-app-wjngb.ondigitalocean.app";
  const LS_PLAYER_PREFIX = "stimulus_selected_player_main_v1";
  const LS_TEAM_PREFIX = "stimulus_selected_team_main_v1";
  const LS_NUMBER_PREFIX = "stimulus_selected_number_main_v1";

  let selectedPlayerPending = null;
  let selectedTeamPending = null;
  let selectedNumberPending = null;

  const playersCache = new Map(); // teamName||"__ALL__" => players[]

  const $popupRoot = $(".loadingPlayerSelectionPopup");
  const collectionId = String($popupRoot.data("collectionid") || "").trim();

  if (!collectionId) {
    console.warn(
      "⚠️ collectionId not found in DOM. Ensure data-collectionid exists."
    );
    return;
  }

  const LS_PLAYER_KEY = `${LS_PLAYER_PREFIX}_${collectionId}`;
  const LS_TEAM_KEY = `${LS_TEAM_PREFIX}_${collectionId}`;
  const LS_NUMBER_KEY = `${LS_NUMBER_PREFIX}_${collectionId}`;

  const LS_POPUP_DISMISS_KEY = `stimulus_player_popup_dismissed_${collectionId}`;
  const POPUP_DISMISS_MS = 6 * 60 * 60 * 1000;

  const TEAM_ALL = "All Players";
  const displayNumber = (number) => String(number).trim() === "0" ? "00" : String(number).trim();

  // =========================
  // club meta cache per collection
  // =========================
  window.StimulusClubMeta = window.StimulusClubMeta || {
    byCollectionId: {},
    set(cid, meta) {
      this.byCollectionId[String(cid)] = meta || {};
    },
    get(cid) {
      return this.byCollectionId[String(cid)] || {};
    },
  };

  // =========================
  // Locked numbers (GLOBAL)
  // =========================
  // ✅ Shared StimulusLocks (supports both call styles)
  window.StimulusLocks = window.StimulusLocks || {};
  (function initLocks() {
    if (window.StimulusLocks.__v2) return;

    const normTeamKey = (s) =>
      String(s || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ");

    window.StimulusLocks.__v2 = true;
    window.StimulusLocks.byTeam = {};
    window.StimulusLocks.all = new Set();
    window.StimulusLocks.loadedForCollectionId = null;
    window.StimulusLocks.apiURL =
      window.StimulusLocks.apiURL ||
      "https://stimulus-athletic-app-wjngb.ondigitalocean.app";

    window.StimulusLocks.ensureLoaded = async function (a, b, c) {
      // supports:
      // ensureLoaded(collectionId, opts)
      // ensureLoaded(apiURL, collectionId, opts)
      const apiURL = typeof b === "string" ? String(a) : this.apiURL;
      const collectionId = typeof b === "string" ? String(b) : String(a);
      const opts = (typeof b === "string" ? c : b) || {};
      const force = !!opts.force;

      const cid = String(collectionId || "").trim();
      if (!cid) return;

      if (!force && this.loadedForCollectionId === cid && this.all.size) return;

      const endpoint = `${apiURL}/api/storefront-club-players?collectionId=${encodeURIComponent(
        cid
      )}`;

      const res = await fetch(endpoint, { method: "GET", cache: "no-store" });
      const data = await res.json();

      // keep meta in sync
      window.StimulusClubMeta = window.StimulusClubMeta || {
        byCollectionId: {},
        set(cid, meta) {
          this.byCollectionId[String(cid)] = meta || {};
        },
        get(cid) {
          return this.byCollectionId[String(cid)] || {};
        },
      };
      window.StimulusClubMeta.set(cid, {
        fcfsEnabled: !!data?.firstComeFirstServe,
      });

      if (!res.ok) throw new Error(data?.error || "Failed to fetch locks");

      const map = data?.lockedNumbersByTeam || {};
      const byTeam = {};
      const all = new Set();

      Object.keys(map).forEach((t) => {
        const teamKey = normTeamKey(t);
        const nums = Array.isArray(map[t]) ? map[t] : [];
        const set = new Set(
          nums
            .map((n) => parseInt(String(n).trim(), 10))
            .filter(Number.isFinite)
        );
        byTeam[teamKey] = set;
        set.forEach((n) => all.add(`${teamKey}:${n}`));
      });

      this.byTeam = byTeam;
      this.all = all;
      this.loadedForCollectionId = cid;
    };

    window.StimulusLocks.isLockedAny = function (number) {
      const n = parseInt(String(number).trim(), 10);
      if (!Number.isFinite(n)) return false;

      // if any team has this number locked => locked globally
      for (const teamKey in this.byTeam) {
        const set = this.byTeam[teamKey];
        if (set instanceof Set && set.has(n)) return true;
      }
      return false;
    };

    window.StimulusLocks.isLocked = function (teamName, number, opts) {
      const n = parseInt(String(number).trim(), 10);
      if (!Number.isFinite(n)) return false;

      const teamKey = normTeamKey(teamName);
      const options = opts || {};

      // ✅ Team-specific lock
      if (teamKey && this.byTeam[teamKey] instanceof Set) {
        return this.byTeam[teamKey].has(n);
      }

      // ✅ NEW: if team unknown and caller wants global locking, lock if locked in ANY team
      if (options.globalIfUnknownTeam) {
        return this.isLockedAny(n);
      }

      // default: unknown team => not locked
      return false;
    };
  })();

  // =========================
  // LocalStorage helpers
  // =========================
  const getSavedPlayer = () => {
    try {
      const raw = localStorage.getItem(LS_PLAYER_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  };

  const savePlayer = (playerObj) => {
    try {
      localStorage.setItem(LS_PLAYER_KEY, JSON.stringify(playerObj));
    } catch (e) {}
    syncHeaderLabel();
  };

  const removeSavedPlayer = () => {
    try {
      localStorage.removeItem(LS_PLAYER_KEY);
    } catch (e) {}
    syncHeaderLabel();
  };

  const getSavedTeam = () => {
    try {
      const raw = localStorage.getItem(LS_TEAM_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  };

  const saveTeam = (teamObj) => {
    try {
      localStorage.setItem(LS_TEAM_KEY, JSON.stringify(teamObj));
    } catch (e) {}
    syncHeaderLabel();
  };

  const removeSavedTeam = () => {
    try {
      localStorage.removeItem(LS_TEAM_KEY);
    } catch (e) {}
    syncHeaderLabel();
  };

  const getSavedNumber = () => {
    try {
      const raw = localStorage.getItem(LS_NUMBER_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  };

  const saveNumber = (numberObj) => {
    try {
      localStorage.setItem(LS_NUMBER_KEY, JSON.stringify(numberObj));
    } catch (e) {}
    syncHeaderLabel();
  };

  const removeSavedNumber = () => {
    try {
      localStorage.removeItem(LS_NUMBER_KEY);
    } catch (e) {}
    syncHeaderLabel();
  };

  // =========================
  // Header / labels
  // =========================
  const buildPlayerLabel = (p) => {
    if (!p) return "Select Player";

    const name =
      p.displayName && String(p.displayName).trim()
        ? String(p.displayName).trim()
        : p.playerName || `${p.firstName || ""} ${p.lastName || ""}`.trim();

    const num =
      p.playerNumber !== null &&
      p.playerNumber !== undefined &&
      String(p.playerNumber).trim() !== ""
        ? ` - ${displayNumber(p.playerNumber)}`
        : "";

    return `${name}${num}`.trim() || "Select Player";
  };

  const applyFcfsHeaderUI = (fcfsEnabled) => {
    if (fcfsEnabled) {
      $(".changePlayerBtn span.link-hover-line").text("Change Team");
      $(".playerSelectedLabel").text("Selected Team:");
    } else {
      $(".changePlayerBtn span.link-hover-line").text("Change Player");
      $(".playerSelectedLabel").text("Selected Player:");
    }
  };

  const syncHeaderLabel = () => {
    const meta = window.StimulusClubMeta.get(collectionId);
    const fcfsEnabled = !!meta?.fcfsEnabled;

    if (fcfsEnabled) {
      const savedTeam = getSavedTeam();
      const savedNumber = getSavedNumber();

      const teamName = savedTeam?.teamName ? String(savedTeam.teamName) : "";
      const numVal = savedNumber?.number != null ? String(savedNumber.number).trim() : "";

      if (teamName) {
        $(".selectedPlayer").show();
        $(".playerSelectedLabel").text("Selected Team:");
        $(".labelPrefix").text(teamName).show();

        if (numVal) {
          $(".selectedNumberWrap").show();
          $(".selectedNumberValue").text(numVal);
        } else {
          $(".selectedNumberWrap").hide();
          $(".selectedNumberValue").text("");
        }

        $(".changePlayerBtn span.link-hover-line").text("Change Team");
        $(".changeNumberBtn").show();
      } else {
        $(".selectedPlayer").hide();
        $(".labelPrefix").hide();
        $(".selectedNumberWrap").hide();
        $(".selectedNumberValue").text("");
        $(".changePlayerBtn span.link-hover-line").text("Select Team");
        $(".changeNumberBtn").hide();
      }

      return;
    }

    const savedPlayer = getSavedPlayer();
    if (savedPlayer) {
      $(".selectedPlayer").show();
      $(".playerSelectedLabel").text("Selected Player:");
      $(".labelPrefix").text(buildPlayerLabel(savedPlayer)).show();
      $(".changePlayerBtn span.link-hover-line").text("Change Player");
    } else {
      $(".selectedPlayer").hide();
      $(".labelPrefix").hide();
      $(".changePlayerBtn span.link-hover-line").text("Select Player");
    }

    $(".selectedNumberWrap").hide();
    $(".selectedNumberValue").text("");
    $(".changeNumberBtn").hide();
  };

  // =========================
  // Popup dismiss helpers
  // =========================
  const setPopupDismissedNow = () => {
    try {
      localStorage.setItem(LS_POPUP_DISMISS_KEY, String(Date.now()));
    } catch (e) {}
  };

  const clearPopupDismissed = () => {
    try {
      localStorage.removeItem(LS_POPUP_DISMISS_KEY);
    } catch (e) {}
  };

  const isPopupDismissedRecently = () => {
    try {
      const raw = localStorage.getItem(LS_POPUP_DISMISS_KEY);
      const ts = raw ? parseInt(raw, 10) : 0;
      if (!ts) return false;
      return Date.now() - ts < POPUP_DISMISS_MS;
    } catch (e) {
      return false;
    }
  };

  // =========================
  // UI helpers
  // =========================
  const openPopup = () => {
    $popupRoot.addClass("isOpen");
    $("body").addClass("popupOpen");
  };

  const closePopup = () => {
    $popupRoot.removeClass("isOpen");
    $("body").removeClass("popupOpen");
  };

  const setDropdownLabel = ($wrapper, labelText, fallback) => {
    $wrapper
      .find(".dropDownSelectedLabel")
      .text(labelText || fallback || "Select");
  };

  const normalize = (s) => String(s || "").trim();

  const showPlayerDropdown = () => {
    $(".playerDataDropDown").show();
    $popupRoot.find(".playerDataDropDown").show();
  };

  const hidePlayerDropdown = () => {
    $(".playerDataDropDown")
      .hide()
      .removeClass("open")
      .find(".dropDownContentWrapper")
      .hide();
    $popupRoot
      .find(".playerDataDropDown")
      .hide()
      .removeClass("open")
      .find(".dropDownContentWrapper")
      .hide();
  };

  const toggleTeamDropdownUI = (show) => {
    const $teamOnPage = $(".teamDataDropDown");
    const $teamInPopup = $popupRoot.find(".teamDataDropDown");

    if (show) {
      $teamOnPage.show();
      $teamInPopup.show();
    } else {
      $teamOnPage
        .hide()
        .removeClass("open")
        .find(".dropDownContentWrapper")
        .hide();
      $teamInPopup
        .hide()
        .removeClass("open")
        .find(".dropDownContentWrapper")
        .hide();
    }
  };

  const toggleNumberDropdownUI = (show, scope) => {
    // scope: "popup" | "page" | undefined (both)
    const $numOnPage = $(".numberDataDropDown");
    const $numInPopup = $popupRoot.find(".numberDataDropDown");

    const apply = ($el, on) => {
      if (on) $el.show();
      else
        $el.hide().removeClass("open").find(".dropDownContentWrapper").hide();
    };

    if (scope === "popup") apply($numInPopup, show);
    else if (scope === "page") apply($numOnPage, show);
    else {
      apply($numOnPage, show);
      apply($numInPopup, show);
    }
  };

  // =========================
  // Dropdown mechanics
  // =========================
  const toggleDropdown = ($wrapper) => {
    const $content = $wrapper.find(".dropDownContentWrapper");

    $(".customDropDownWrapper")
      .not($wrapper)
      .removeClass("open")
      .find(".dropDownContentWrapper")
      .stop(true, true)
      .slideUp(300);

    $wrapper.toggleClass("open");
    $content.stop(true, true).slideToggle(300);
  };

  const closeAllDropdowns = () => {
    $(".customDropDownWrapper")
      .removeClass("open")
      .find(".dropDownContentWrapper")
      .stop(true, true)
      .slideUp(300);
  };

  $(document).on(
    "click",
    ".teamDropDownOpener, .playerDropDownOpener, .numberDropDownOpener",
    function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleDropdown($(this).closest(".customDropDownWrapper"));
    }
  );

  $(document).on(
    "click",
    ".customDropDownWrapper .dropDownContentWrapper",
    function (e) {
      e.stopPropagation();
    }
  );

  $(document).on("click", function (e) {
    if ($(e.target).closest(".customDropDownWrapper").length === 0)
      closeAllDropdowns();
  });

  // =========================
  // Render Teams & Players
  // =========================
  const renderTeamsIntoDropdown = (
    $targetArea,
    teams,
    allPlayers,
    { fcfsEnabled } = {}
  ) => {
    $targetArea.empty();

    const hasPlayersWithoutTeam = Array.isArray(allPlayers)
      ? allPlayers.some((p) => !p.teamName)
      : false;

    if (!fcfsEnabled && (hasPlayersWithoutTeam || teams.length > 1)) {
      $targetArea.append(`
        <button type="button" class="teamInfoSelector dropdownElemBtn" data-team="${TEAM_ALL}">
          All Players
        </button>
      `);
    }

    if (!Array.isArray(teams) || !teams.length) {
      $targetArea.append(`<div class="dropdownEmptyMsg">No teams found.</div>`);
      return;
    }

    teams.forEach((t) => {
      const rawTeam = String(t || "").trim();
      const safeLabel = $("<div>").text(rawTeam).html();
      const encoded = encodeURIComponent(rawTeam);

      $targetArea.append(`
        <button type="button" class="teamInfoSelector dropdownElemBtn" data-team="${encoded}">
          ${safeLabel}
        </button>
      `);
    });
  };

  const renderPlayersIntoDropdown = ($targetArea, players) => {
    $targetArea.empty();

    $targetArea.append(`
      <button type="button" class="playerInfoSelector dropdownElemBtn noPlayerSelector" data-player="__NO_PLAYER__">
        No Player
      </button>
    `);

    if (!Array.isArray(players) || players.length === 0) {
      $targetArea.append(
        `<div class="dropdownEmptyMsg">No players found.</div>`
      );
      return;
    }

    players.forEach((p) => {
      const label = buildPlayerLabel(p);
      const payload = encodeURIComponent(JSON.stringify(p));
      $targetArea.append(`
        <button type="button" class="playerInfoSelector dropdownElemBtn" data-player="${payload}">
          ${label}
        </button>
      `);
    });
  };

  // =========================
  // Zero and 00 share the same lock but remain separate display choices.
  // =========================
  const buildNumbersList = () => {
    const list = [
      { value: "00", numeric: 0 },
      { value: "0", numeric: 0 },
    ];
    for (let i = 1; i <= 99; i++) list.push({ value: String(i), numeric: i });
    return list;
  };

  const renderNumbersIntoDropdown = ($targetArea, teamName) => {
    $targetArea.empty();
    const t = String(teamName || "").trim();

    const list = buildNumbersList();

    const buttons = list
      .filter((x) => !window.StimulusLocks.isLocked(t, x.numeric))
      .map(
        (x) => `
          <button type="button" class="numberInfoSelector dropdownElemBtn" data-number="${x.value}">
            ${x.value}
          </button>
        `
      );

    if (!buttons.length) {
      $targetArea.html(
        `<div class="dropdownEmptyMsg">No numbers available.</div>`
      );
      return;
    }

    $targetArea.html(buttons.join(""));
  };

  const applyNumberToAllProductCards = (numVal) => {
    const v = numVal == null ? "" : String(numVal).trim();
    if (!v) return;

    $(".prodInfoContainer .playerNumberItem").each(function () {
      $(this).text(v);
    });

    $(".prodInfoContainer .playerInitalItem").each(function () {
      if ($(this).text().trim() === "" || $(this).text().trim() === "N/A") {
        $(this).text(v);
      }
    });
  };

  // =========================
  // Player card DOM sync
  // =========================
  const cacheOriginalPlayerInfoHTML = () => {
    $(".prodInfoContainer .playerInfo").each(function () {
      const $info = $(this);
      if ($info.data("originalHtml")) return;
      $info.data("originalHtml", $info.html());
    });
  };

  const getPlayerDisplayName = (p) => {
    if (!p) return "";
    return (
      (p.displayName && String(p.displayName).trim()) ||
      p.playerName ||
      `${p.firstName || ""} ${p.lastName || ""}`.trim() ||
      ""
    );
  };

  const getPlayerNumberText = (p) => {
    if (!p) return "";
    const n = p.playerNumber;
    if (n === null || n === undefined || String(n).trim() === "") return "";
    return displayNumber(n);
  };

  const applyPlayerToAllProductCards = (playerObj) => {
    if (!playerObj || playerObj.__noPlayer) {
      $(".prodInfoContainer .playerInfo").each(function () {
        const $info = $(this);
        const original = $info.data("originalHtml");
        if (original != null) $info.html(original);
      });
      return;
    }

    const displayName = getPlayerDisplayName(playerObj);
    const numberTxt = getPlayerNumberText(playerObj);

    $(".prodInfoContainer .playerInfo").each(function () {
      const $info = $(this);

      const $nameEl = $info.find(".displayNameTxtElem");
      if ($nameEl.length) {
        $nameEl.text(displayName || $nameEl.text());
        $info.find(".editNameBtn").remove();
      }

      const $numEl = $info.find(".playerNumberItem");
      if ($numEl.length && numberTxt) {
        $numEl.text(numberTxt);
        $info.find(".editNumberBtn").remove();
      }

      const $initEl = $info.find(".playerInitalItem");
      if ($initEl.length && numberTxt) {
        $initEl.text(numberTxt);
        $info.find(".editInitialOrNumber").remove();
      }
    });
  };

  // =========================
  // API loaders
  // =========================
  const fetchTeamsAndAllPlayers = async () => {
    const endpoint = `${apiURL}/api/storefront-club-players?collectionId=${encodeURIComponent(
      collectionId
    )}`;
    const res = await fetch(endpoint, { method: "GET" });
    const data = await res.json();
    if (!res.ok)
      throw new Error(data?.error || "Failed to fetch players/teams");
    return data;
  };

  const fetchPlayersByTeam = async (teamName) => {
    const key = teamName ? normalize(teamName) : "__ALL__";
    if (playersCache.has(key)) return playersCache.get(key);

    const endpoint = teamName
      ? `${apiURL}/api/storefront-club-players?collectionId=${encodeURIComponent(
          collectionId
        )}&teamName=${encodeURIComponent(teamName)}`
      : `${apiURL}/api/storefront-club-players?collectionId=${encodeURIComponent(
          collectionId
        )}`;

    const res = await fetch(endpoint, { method: "GET" });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.error || "Failed to fetch players");

    const players = data?.players || [];
    playersCache.set(key, players);
    return players;
  };

  // =========================
  // ✅ FIX HELPERS (keep old code, just add these)
  // =========================
  const isClickFromPopup = (elem) =>
    $(elem).closest(".loadingPlayerSelectionPopup").length > 0;

  const resetPopupFcfsNumberUI = () => {
    // Always reset number pending + label + list active state
    selectedNumberPending = null;
    setDropdownLabel(
      $popupRoot.find(".numberDataDropDown"),
      "Select Number",
      "Select Number"
    );
    $popupRoot
      .find(".allNumberRecordsArea .numberInfoSelector")
      .removeClass("active");
  };

  const getPopupNumbersArea = () =>
    $popupRoot.find(".numberDataDropDown .allNumberRecordsArea");

  const getPageNumbersArea = () =>
    $(".numberDataDropDown")
      .not($popupRoot.find(".numberDataDropDown"))
      .find(".allNumberRecordsArea");

  const rebuildFcfsNumbersEverywhere = (teamName) => {
    toggleNumberDropdownUI(true);

    const $popupArea = getPopupNumbersArea();
    const $pageArea = getPageNumbersArea();

    renderNumbersIntoDropdown($popupArea, teamName);
    renderNumbersIntoDropdown($pageArea, teamName);

    setDropdownLabel(
      $popupRoot.find(".numberDataDropDown"),
      "Select Number",
      "Select Number"
    );
    setDropdownLabel(
      $(".numberDataDropDown"),
      "Select Number",
      "Select Number"
    );

    // clear active state
    $popupArea.find(".numberInfoSelector").removeClass("active");
    $pageArea.find(".numberInfoSelector").removeClass("active");
  };

  // =========================
  // Main load
  // =========================
  const loadTeamsAndPlayers = async () => {
    $popupRoot.find(".loadingAnim").show();
    $popupRoot.find(".popUpFormArea").hide();

    try {
      const data = await fetchTeamsAndAllPlayers();
      await window.StimulusLocks.ensureLoaded(apiURL, collectionId, {
        force: true,
      });

      const fcfsEnabled = !!data?.firstComeFirstServe;
      window.StimulusClubMeta.set(collectionId, { fcfsEnabled });
      applyFcfsHeaderUI(fcfsEnabled);

      const teams = Array.isArray(data?.teams) ? data.teams : [];
      const allPlayers = Array.isArray(data?.players) ? data.players : [];

      playersCache.set("__ALL__", allPlayers);

      const teamsEmptyButPlayersExist =
        teams.length === 0 && allPlayers.length > 0;

      if (teamsEmptyButPlayersExist) {
        toggleTeamDropdownUI(false);
        toggleNumberDropdownUI(false);

        removeSavedTeam();
        removeSavedNumber();
        selectedTeamPending = null;
        selectedNumberPending = null;

        showPlayerDropdown();

        renderPlayersIntoDropdown(
          $popupRoot.find(".allPLayerRecordsArea"),
          allPlayers
        );
        renderPlayersIntoDropdown(
          $(".playerDataDropDown .allPLayerRecordsArea"),
          allPlayers
        );

        setDropdownLabel(
          $(".playerDataDropDown"),
          "Select Player",
          "Select Player"
        );
        setDropdownLabel(
          $popupRoot.find(".playerDataDropDown"),
          "Select Player",
          "Select Player"
        );

        const savedPlayer = getSavedPlayer();
        if (savedPlayer) {
          setDropdownLabel(
            $(".playerDataDropDown"),
            buildPlayerLabel(savedPlayer),
            "Select Player"
          );
          setDropdownLabel(
            $popupRoot.find(".playerDataDropDown"),
            buildPlayerLabel(savedPlayer),
            "Select Player"
          );
        }

        $popupRoot.find(".loadingAnim").hide();
        $popupRoot.find(".popUpFormArea").show();
        return;
      }

      // ✅ FCFS: Team then Number (Number hidden until team)
      if (fcfsEnabled) {
        toggleTeamDropdownUI(true);
        hidePlayerDropdown();
        removeSavedPlayer();

        renderTeamsIntoDropdown(
          $popupRoot.find(".allTeamRecordsArea"),
          teams,
          allPlayers,
          { fcfsEnabled: true }
        );
        renderTeamsIntoDropdown(
          $(".teamDataDropDown .allTeamRecordsArea"),
          teams,
          allPlayers,
          { fcfsEnabled: true }
        );

        const savedTeamObj = getSavedTeam();
        const savedTeamName = savedTeamObj?.teamName
          ? String(savedTeamObj.teamName).trim()
          : "";

        const savedNumObj = getSavedNumber();
        const savedNum = savedNumObj?.number
          ? String(savedNumObj.number).trim()
          : "";

        selectedTeamPending = savedTeamName
          ? { teamName: savedTeamName }
          : null;
        selectedNumberPending = savedNum ? { number: savedNum } : null;

        if (savedTeamName) {
          toggleNumberDropdownUI(true);

          setDropdownLabel(
            $(".teamDataDropDown"),
            savedTeamName,
            "Select Team"
          );
          setDropdownLabel(
            $popupRoot.find(".teamDataDropDown"),
            savedTeamName,
            "Select Team"
          );

          renderNumbersIntoDropdown(
            $popupRoot.find(".allNumberRecordsArea"),
            savedTeamName
          );
          renderNumbersIntoDropdown(
            $(".numberDataDropDown .allNumberRecordsArea"),
            savedTeamName
          );

          setDropdownLabel(
            $popupRoot.find(".numberDataDropDown"),
            savedNum || "Select Number",
            "Select Number"
          );
          setDropdownLabel(
            $(".numberDataDropDown"),
            savedNum || "Select Number",
            "Select Number"
          );

          rebuildFcfsNumbersEverywhere(savedTeamName);

          if (savedNum) applyNumberToAllProductCards(savedNum);
        } else {
          toggleNumberDropdownUI(false);

          setDropdownLabel(
            $popupRoot.find(".numberDataDropDown"),
            "Select Number",
            "Select Number"
          );
          setDropdownLabel(
            $(".numberDataDropDown"),
            "Select Number",
            "Select Number"
          );

          $popupRoot
            .find(".allNumberRecordsArea")
            .html(`<div class="dropdownEmptyMsg">Select team first.</div>`);
          $(".numberDataDropDown .allNumberRecordsArea").html(
            `<div class="dropdownEmptyMsg">Select team first.</div>`
          );
        }

        $popupRoot.find(".loadingAnim").hide();
        $popupRoot.find(".popUpFormArea").show();
        return;
      }

      // ✅ Normal: Team + Player
      toggleTeamDropdownUI(true);
      toggleNumberDropdownUI(false);

      renderTeamsIntoDropdown(
        $popupRoot.find(".allTeamRecordsArea"),
        teams,
        allPlayers
      );
      renderTeamsIntoDropdown(
        $(".teamDataDropDown .allTeamRecordsArea"),
        teams,
        allPlayers
      );

      const savedTeamObj = getSavedTeam();
      const savedTeamName = savedTeamObj?.teamName
        ? String(savedTeamObj.teamName)
        : null;

      if (savedTeamName) {
        const isAll = savedTeamName === TEAM_ALL;
        const teamLabel = isAll ? "All Players" : savedTeamName;

        setDropdownLabel($(".teamDataDropDown"), teamLabel, "Select Team");
        setDropdownLabel(
          $popupRoot.find(".teamDataDropDown"),
          teamLabel,
          "Select Team"
        );

        showPlayerDropdown();

        const initialPlayers = isAll
          ? allPlayers
          : await fetchPlayersByTeam(savedTeamName);

        renderPlayersIntoDropdown(
          $popupRoot.find(".allPLayerRecordsArea"),
          initialPlayers
        );
        renderPlayersIntoDropdown(
          $(".playerDataDropDown .allPLayerRecordsArea"),
          initialPlayers
        );
      } else {
        setDropdownLabel($(".teamDataDropDown"), "Select Team", "Select Team");
        setDropdownLabel(
          $popupRoot.find(".teamDataDropDown"),
          "Select Team",
          "Select Team"
        );

        hidePlayerDropdown();

        renderPlayersIntoDropdown($popupRoot.find(".allPLayerRecordsArea"), []);
        renderPlayersIntoDropdown(
          $(".playerDataDropDown .allPLayerRecordsArea"),
          []
        );
      }

      const savedPlayer = getSavedPlayer();
      if (savedTeamName && savedPlayer) {
        setDropdownLabel(
          $(".playerDataDropDown"),
          buildPlayerLabel(savedPlayer),
          "Select Player"
        );
        setDropdownLabel(
          $popupRoot.find(".playerDataDropDown"),
          buildPlayerLabel(savedPlayer),
          "Select Player"
        );
      } else {
        setDropdownLabel(
          $(".playerDataDropDown"),
          "Select Player",
          "Select Player"
        );
        setDropdownLabel(
          $popupRoot.find(".playerDataDropDown"),
          "Select Player",
          "Select Player"
        );
      }

      $popupRoot.find(".loadingAnim").hide();
      $popupRoot.find(".popUpFormArea").show();
    } catch (err) {
      console.error("❌ Team/player load error:", err);

      $popupRoot.find(".loadingAnim").hide();
      $popupRoot.find(".popUpFormArea").show();

      $popupRoot
        .find(".allTeamRecordsArea")
        .html(`<div class="dropdownEmptyMsg">No team available.</div>`);
      $popupRoot
        .find(".allPLayerRecordsArea")
        .html(`<div class="dropdownEmptyMsg">No player available.</div>`);

      hidePlayerDropdown();
      toggleNumberDropdownUI(false);
    }
  };

  // =========================
  // Popup decision
  // =========================
  const initPopupOrPrefill = () => {
    const savedTeam = getSavedTeam();
    const savedPlayer = getSavedPlayer();
    const savedNum = getSavedNumber();

    if (savedTeam || savedPlayer || savedNum) {
      closePopup();
      clearPopupDismissed();
      return;
    }

    if (isPopupDismissedRecently()) {
      closePopup();
      return;
    }

    openPopup();
  };

  // =========================
  // ✅ Team selection (FULL FIX inside your version)
  // =========================
  $(document).on("click", ".teamInfoSelector", async function (e) {
    e.preventDefault();
    e.stopPropagation();

    const rawAttr = $(this).attr("data-team");
    if (!rawAttr) return;

    const meta = window.StimulusClubMeta.get(collectionId);
    const fcfsEnabled = !!meta?.fcfsEnabled;

    const $btn = $(this);
    const $area = $btn.closest(".allTeamRecordsArea");

    // ✅ FIX: robust popup detection (old one was unreliable sometimes)
    const isPopupDropdown = isClickFromPopup(this);

    $area.find(".teamInfoSelector").removeClass("active");
    $btn.addClass("active");

    // ✅ FCFS
    if (fcfsEnabled) {
      const teamName =
        rawAttr === TEAM_ALL ? TEAM_ALL : decodeURIComponent(rawAttr);
      const cleanTeam = String(teamName || "").trim();
      if (!cleanTeam) return;

      // ✅ store pending
      selectedTeamPending = { teamName: cleanTeam };
      selectedNumberPending = null;

      // ✅ SAVE TEAM IMMEDIATELY ON CLICK (popup + page)
      saveTeam({ teamName: cleanTeam });

      // ✅ when team changes, number must reset
      removeSavedNumber();
      setDropdownLabel(
        $popupRoot.find(".numberDataDropDown"),
        "Select Number",
        "Select Number"
      );
      setDropdownLabel(
        $(".numberDataDropDown"),
        "Select Number",
        "Select Number"
      );

      // ✅ update TEAM label in both places
      setDropdownLabel(
        $popupRoot.find(".teamDataDropDown"),
        cleanTeam,
        "Select Team"
      );
      setDropdownLabel($(".teamDataDropDown"), cleanTeam, "Select Team");

      // ✅ show number dropdown in both places
      toggleNumberDropdownUI(true);

      await window.StimulusLocks.ensureLoaded(apiURL, collectionId, {
        force: true,
      });

      // ✅ IMPORTANT: re-render numbers for this team (locked numbers auto filtered)
      renderNumbersIntoDropdown(
        $popupRoot.find(".allNumberRecordsArea"),
        cleanTeam
      );
      renderNumbersIntoDropdown(
        $(".numberDataDropDown .allNumberRecordsArea"),
        cleanTeam
      );

      rebuildFcfsNumbersEverywhere(cleanTeam);

      // ✅ clear active number selections
      $popupRoot
        .find(".allNumberRecordsArea .numberInfoSelector")
        .removeClass("active");
      $(
        ".numberDataDropDown .allNumberRecordsArea .numberInfoSelector"
      ).removeClass("active");

      // ✅ FCFS doesn't use player
      removeSavedPlayer();

      closeAllDropdowns();
      return;
    }

    // ======================
    // Normal mode (unchanged from your code)
    // ======================
    const teamName =
      rawAttr === TEAM_ALL ? TEAM_ALL : decodeURIComponent(rawAttr);
    const cleanTeam = String(teamName || "").trim();
    if (!cleanTeam) return;

    if (cleanTeam === TEAM_ALL) {
      const players = playersCache.get("__ALL__") || [];
      if (isPopupDropdown) {
        selectedTeamPending = { teamName: TEAM_ALL };
        selectedPlayerPending = null;

        setDropdownLabel(
          $popupRoot.find(".teamDataDropDown"),
          "All Players",
          "All Players"
        );
        setDropdownLabel(
          $popupRoot.find(".playerDataDropDown"),
          "Select Player",
          "Select Player"
        );

        showPlayerDropdown();
        renderPlayersIntoDropdown(
          $popupRoot.find(".allPLayerRecordsArea"),
          players
        );

        closeAllDropdowns();
        return;
      }

      saveTeam({ teamName: TEAM_ALL });
      removeSavedPlayer();

      setDropdownLabel($(".teamDataDropDown"), "All Players", "All Players");
      setDropdownLabel(
        $(".playerDataDropDown"),
        "Select Player",
        "Select Player"
      );

      showPlayerDropdown();
      renderPlayersIntoDropdown(
        $(".playerDataDropDown .allPLayerRecordsArea"),
        players
      );

      applyPlayerToAllProductCards({ __noPlayer: true });
      closeAllDropdowns();
      return;
    }

    const players = await fetchPlayersByTeam(cleanTeam);

    if (isPopupDropdown) {
      selectedTeamPending = { teamName: cleanTeam };
      selectedPlayerPending = null;

      setDropdownLabel(
        $popupRoot.find(".teamDataDropDown"),
        cleanTeam,
        "Select Team"
      );
      setDropdownLabel(
        $popupRoot.find(".playerDataDropDown"),
        "Select Player",
        "Select Player"
      );

      showPlayerDropdown();
      renderPlayersIntoDropdown(
        $popupRoot.find(".allPLayerRecordsArea"),
        players
      );

      closeAllDropdowns();
      return;
    }

    saveTeam({ teamName: cleanTeam });
    removeSavedPlayer();

    setDropdownLabel($(".teamDataDropDown"), cleanTeam, "Select Team");
    setDropdownLabel(
      $(".playerDataDropDown"),
      "Select Player",
      "Select Player"
    );

    showPlayerDropdown();
    renderPlayersIntoDropdown(
      $(".playerDataDropDown .allPLayerRecordsArea"),
      players
    );

    applyPlayerToAllProductCards({ __noPlayer: true });
    closeAllDropdowns();
  });

  // =========================
  // Player selection (unchanged)
  // =========================
  $(document).on("click", ".playerInfoSelector", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const raw = $(this).attr("data-player");
    if (!raw) return;

    const $btn = $(this);
    const $area = $btn.closest(".allPLayerRecordsArea");
    const isPopupDropdown = isClickFromPopup(this);

    $area.find(".playerInfoSelector").removeClass("active");
    $btn.addClass("active");

    if (raw === "__NO_PLAYER__") {
      if (isPopupDropdown) {
        selectedPlayerPending = { __noPlayer: true };
        setDropdownLabel(
          $popupRoot.find(".playerDataDropDown"),
          "No Player",
          "Select Player"
        );
        closeAllDropdowns();
        return;
      }

      removeSavedPlayer();
      setDropdownLabel(
        $(".playerDataDropDown"),
        "Select Player",
        "Select Player"
      );
      applyPlayerToAllProductCards({ __noPlayer: true });
      closeAllDropdowns();
      return;
    }

    const playerObj = JSON.parse(decodeURIComponent(raw));
    const label = buildPlayerLabel(playerObj);

    if (isPopupDropdown) {
      selectedPlayerPending = playerObj;
      setDropdownLabel(
        $popupRoot.find(".playerDataDropDown"),
        label,
        "Select Player"
      );
      closeAllDropdowns();
      return;
    }

    savePlayer(playerObj);
    setDropdownLabel($(".playerDataDropDown"), label, "Select Player");
    applyPlayerToAllProductCards(playerObj);
    closeAllDropdowns();
  });

  // =========================
  // Number selection (mostly unchanged, but popup detection fixed)
  // =========================
  $(document).on("click", ".numberInfoSelector", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const raw = String($(this).attr("data-number") || "").trim();
    if (!raw) return;

    const meta = window.StimulusClubMeta.get(collectionId);
    const fcfsEnabled = !!meta?.fcfsEnabled;

    const $btn = $(this);
    const $area = $btn.closest(".allNumberRecordsArea");
    const isPopupDropdown = isClickFromPopup(this);

    $area.find(".numberInfoSelector").removeClass("active");
    $btn.addClass("active");

    if (fcfsEnabled && isPopupDropdown && !selectedTeamPending?.teamName) {
      alert("Please select a team first.");
      return;
    }

    if (isPopupDropdown) {
      selectedNumberPending = { number: raw };
      setDropdownLabel(
        $popupRoot.find(".numberDataDropDown"),
        raw,
        "Select Number"
      );
      closeAllDropdowns();
      return;
    }

    saveNumber({ number: raw });
    setDropdownLabel($(".numberDataDropDown"), raw, "Select Number");
    applyNumberToAllProductCards(raw);
    closeAllDropdowns();
  });

  // =========================
  // Continue (popup) (unchanged)
  // =========================
  $(document).on("click", ".selectionActionBtnForPlayer", function () {
    const meta = window.StimulusClubMeta.get(collectionId);
    const fcfsEnabled = !!meta?.fcfsEnabled;

    if (fcfsEnabled) {
      console.log("fcfsEnabled = "+ fcfsEnabled);
      if (!selectedTeamPending?.teamName) {
        alert("Please select a team to continue.");
        return;
      }
      if (!selectedNumberPending?.number) {
        alert("Please select a number to continue.");
        return;
      }

      saveTeam(selectedTeamPending);
      saveNumber(selectedNumberPending);

      setDropdownLabel(
        $(".teamDataDropDown"),
        selectedTeamPending.teamName,
        "Select Team"
      );
      setDropdownLabel(
        $(".numberDataDropDown"),
        selectedNumberPending.number,
        "Select Number"
      );

      rebuildFcfsNumbersEverywhere(selectedTeamPending?.teamName);

      applyNumberToAllProductCards(selectedNumberPending.number);

      removeSavedPlayer();
      closePopup();

      selectedTeamPending = null;
      selectedNumberPending = null;
      selectedPlayerPending = null;
      return;
    }

    const isTeamDropdownVisible =
      $popupRoot.find(".teamDataDropDown:visible").length > 0;

    if (
      isTeamDropdownVisible &&
      (!selectedTeamPending || !selectedTeamPending.teamName)
    ) {
      removeSavedTeam();
      removeSavedPlayer();

      setDropdownLabel($(".teamDataDropDown"), "Select Team", "Select Team");
      setDropdownLabel(
        $(".playerDataDropDown"),
        "Select Player",
        "Select Player"
      );

      hidePlayerDropdown();
      applyPlayerToAllProductCards({ __noPlayer: true });

      closePopup();
      clearPopupDismissed();
      selectedTeamPending = null;
      selectedPlayerPending = null;
      return;
    }

    if (selectedTeamPending && selectedTeamPending.teamName) {
      saveTeam(selectedTeamPending);
      setDropdownLabel(
        $(".teamDataDropDown"),
        selectedTeamPending.teamName,
        "Select Team"
      );
    } else {
      removeSavedTeam();
    }

    if (selectedPlayerPending) {
      if (selectedPlayerPending.__noPlayer) {
        removeSavedPlayer();
        setDropdownLabel(
          $(".playerDataDropDown"),
          "Select Player",
          "Select Player"
        );
        applyPlayerToAllProductCards({ __noPlayer: true });
      } else {
        savePlayer(selectedPlayerPending);
        setDropdownLabel(
          $(".playerDataDropDown"),
          buildPlayerLabel(selectedPlayerPending),
          "Select Player"
        );
        applyPlayerToAllProductCards(selectedPlayerPending);
      }
    } else {
      removeSavedPlayer();
      setDropdownLabel(
        $(".playerDataDropDown"),
        "Select Player",
        "Select Player"
      );
      applyPlayerToAllProductCards({ __noPlayer: true });
    }

    closePopup();
    selectedTeamPending = null;
    selectedPlayerPending = null;
  });

  // =========================
  // Popup close/open
  // =========================
  $(document).on("click", ".closePopupElem", function () {
    const savedPlayer = getSavedPlayer();
    const savedTeam = getSavedTeam();
    const savedNum = getSavedNumber();

    if (!savedPlayer && !savedTeam && !savedNum) {
      setPopupDismissedNow();
    }

    closePopup();
  });

  $(document).on("click", ".openPlayerSelectionPopupBtn", function (e) {
    e.preventDefault();
    openPopup();
  });

  // =========================
  // Init
  // =========================
  cacheOriginalPlayerInfoHTML();
  initPopupOrPrefill();
  loadTeamsAndPlayers();
  syncHeaderLabel();

  const savedNumObj = getSavedNumber();
  const savedNum = savedNumObj?.number ? String(savedNumObj.number) : "";
  if (savedNum) applyNumberToAllProductCards(savedNum);

  const savedInit = getSavedPlayer();
  if (savedInit) applyPlayerToAllProductCards(savedInit);
  else applyPlayerToAllProductCards({ __noPlayer: true });
});
